import React, { useState } from 'react';
import { NavLink, useNavigate } from 'react-router-dom';
import { useAuth } from '../AuthContext';
import {
  LayoutDashboard, Clock, FolderOpen, CalendarOff, BarChart3, Users,
  FileSpreadsheet, Download, LogOut, Key, Menu, X
} from 'lucide-react';

const Layout = ({ children }) => {
  const { user, logout, isAdmin } = useAuth();
  const navigate = useNavigate();
  const [sidebarOpen, setSidebarOpen] = useState(false);

  const handleLogout = () => {
    logout();
    navigate('/login');
  };

  const initials = user ? `${user.first_name?.[0] || ''}${user.last_name?.[0] || ''}` : '?';

  return (
    <div className="app-layout">
      <button className="mobile-menu-btn" onClick={() => setSidebarOpen(!sidebarOpen)}>
        {sidebarOpen ? <X size={20} /> : <Menu size={20} />}
      </button>

      <aside className={`sidebar ${sidebarOpen ? 'open' : ''}`}>
        <div className="sidebar-header">
          <img src="/logo-square-bw.png" alt="soft-evolution" className="sidebar-logo" />
          <h1>Zeitverwaltung</h1>
          <p>Stunden- & Projektverwaltung</p>
        </div>

        <nav className="sidebar-nav" onClick={() => setSidebarOpen(false)}>
          <div className="sidebar-section">Allgemein</div>
          <NavLink to="/" end><LayoutDashboard size={18} /> Dashboard</NavLink>
          <NavLink to="/zeiterfassung"><Clock size={18} /> Zeiterfassung</NavLink>
          <NavLink to="/projekte"><FolderOpen size={18} /> Projekte</NavLink>
          <NavLink to="/abwesenheiten"><CalendarOff size={18} /> Abwesenheiten</NavLink>
          <NavLink to="/auswertung"><BarChart3 size={18} /> Auswertung</NavLink>

          {isAdmin && (
            <>
              <div className="sidebar-section">Administration</div>
              <NavLink to="/admin/benutzer"><Users size={18} /> Benutzer</NavLink>
              <NavLink to="/admin/zeiteintraege"><FileSpreadsheet size={18} /> Alle Einträge</NavLink>
              <NavLink to="/admin/export"><Download size={18} /> Export</NavLink>
            </>
          )}

          <div className="sidebar-section">Konto</div>
          <NavLink to="/passwort"><Key size={18} /> Passwort ändern</NavLink>
          <button onClick={handleLogout}><LogOut size={18} /> Abmelden</button>
        </nav>

        <div className="sidebar-footer">
          <div className="user-info">
            <div className="user-avatar">{initials}</div>
            <div>
              <div className="user-name">{user?.first_name} {user?.last_name}</div>
              <div className="user-role">{user?.role === 'admin' ? 'Administrator' : 'Benutzer'}</div>
            </div>
          </div>
        </div>
      </aside>

      <main className="main-content">
        {children}
      </main>
    </div>
  );
};

export default Layout;
